import { BlankSlate, Box, Button, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import Disclosure from 'modules/payroll_bundle/components/Disclosure'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'

import { usePayrollBundlePageContext } from '../PayrollBundle'

const EmptyState = () => {
  const { navigation } = useNavigation()

  const { currentPeriod } = usePolicyPeriods()

  const { selectedPolicy } = usePayrollBundlePageContext()
  const policyId = selectedPolicy.id

  const currentPeriodId = currentPeriod?.id

  const onImportResultsClick = () => {
    track(trackingEvents.payroll.userClicksOnImportPayrollCycleResults)
  }

  return (
    <Box gap="s8" style={{ flex: '1' }}>
      <Box height="s32" flexDirection="row" alignItems="center" paddingX="s8">
        <Text.Normal weight="medium" size="300" color="grey800">
          {i18n.t('payroll_bundle.payroll_dashboard.payment_summary.widget_title')}
        </Text.Normal>
        <Disclosure
          tooltipText={i18n.t(
            'payroll_bundle.payroll_dashboard.payment_summary.heading_tooltip.tooltip_v2'
          )}
        />
      </Box>
      <Box
        style={{ flex: '1' }}
        height="s240"
        border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
        borderRadius={{ all: 'abs016' }}
        minHeight="s240"
      >
        <BlankSlate
          description={i18n.t(
            'payroll_bundle.payroll_dashboard.payment_summary.payment_widget.empty.title'
          )}
          illustration="analytics-bars"
          size="small"
        >
          <Button.Router
            type="secondary"
            to={navigation.payrollBundle.policy.period.cycles.results.fullPath({
              policyId: policyId,
              periodId: currentPeriodId,
            })}
            onClick={onImportResultsClick}
          >
            {i18n.t(
              'payroll_bundle.payroll_dashboard.payment_summary.payment_widget.empty.button_text'
            )}
          </Button.Router>
        </BlankSlate>
      </Box>
    </Box>
  )
}

export default EmptyState
